module.exports = __webpack_public_path__ + "img/logo_life.6c6d1d04.jpg";